import { gql } from "@lytra/frontend-common/__generated__";

// Writing notes and seeing colleagues' notes arrive (#654). Every operation is named
// TicketNote* because operation names are unique across the monorepo's shared generated registry.

// `text` carries the stored form (mention tokens `@[Name](user:<id>)`), see noteMentions.ts.
// Server refusals arrive as GraphQL errors with a German message.
export const TICKET_NOTE_CREATE = gql(`
  mutation TicketNoteCreate(
    $conversationId: UUID!
    $text: String!
    $clientRequestId: UUID!
    $parentMessageId: UUID
  ) {
    noteCreate(
      conversationId: $conversationId
      text: $text
      clientRequestId: $clientRequestId
      parentMessageId: $parentMessageId
    ) {
      id
    }
  }
`);

// The subscription is tenant-wide; the ticket filters by conversation and by the flags
// (note, send, internal row) before it refetches (T-02-27). A colleague's mail reply and a
// send are internal rows, not notes, so they need their own flags here (#717).
export const TICKET_NOTE_UPDATES = gql(`
  subscription TicketNoteUpdates {
    messages {
      id
      conversationId
      isNote
      isForward
      isInternal
    }
  }
`);

// Author-only (#654): the server answers null for a note that is not the caller's,
// or (update) was deleted meanwhile; the caller treats null as "no longer yours to change".
export const TICKET_NOTE_UPDATE = gql(`
  mutation TicketNoteUpdate($messageId: UUID!, $text: String!) {
    noteUpdate(messageId: $messageId, text: $text) {
      id
      contentText
      editedAt
      deletedAt
    }
  }
`);

// A repeated delete returns the note again, so a double click or a retry is harmless.
export const TICKET_NOTE_DELETE = gql(`
  mutation TicketNoteDelete($messageId: UUID!) {
    noteDelete(messageId: $messageId) {
      id
      deletedAt
    }
  }
`);
